import { translateProjectFeasibilityText } from "../../i18n/projectFeasibilityGreek";
import { formatApiError } from "../../utils/apiErrors";
import { isDefaultMaintenanceMessage, maintenanceNotice } from "../../i18n/maintenanceMessages";

  const PHASE_LABELS = {
    shading: ["Scene shading", "Υπολογισμός σκιάσεων σκηνής"],
    validate: ["Inputs Validation", "Έλεγχος δεδομένων εισόδου"],
    timeseries: ["Timeseries Construction", "Κατασκευή χρονοσειρών"],
    pv_generation: ["PV Generation", "Παραγωγή Φ/Β"],
    pv_accounting: ["PV energy balance and financial analysis", "Ενεργειακό ισοζύγιο και οικονομική ανάλυση Φ/Β"],
    pv_financial_risk: ["PV financial risk analysis", "Οικονομική ανάλυση μεταβλητότητας ΦΒ"],
    optimization: ["BESS Optimization", "Βελτιστοποίηση BESS"],
    persist: ["Saving results", "Αποθήκευση αποτελεσμάτων"],
    pv_profiles: ["Preparing historical PV profiles", "Προετοιμασία ιστορικών προφίλ ΦΒ"],
    pv_operating: ["Historical operating scenarios", "Υπολογισμός ιστορικών σεναρίων λειτουργίας"],
    reference_study: ["Reference study", "Μελέτη αναφοράς"],
    pv_financial_metrics: ["Financial analysis", "Οικονομική ανάλυση"],
    finalizing: ["Final checks", "Τελικοί έλεγχοι αποτελεσμάτων"],
    reports: ["Creating reports", "Δημιουργία αναφορών"],
    queued: ["Waiting for a worker", "Αναμονή εκτέλεσης"],
    completed: ["Success", "Ολοκληρώθηκε"],
  };
  export const mapPhaseLabel = (phase, isGreek = false) => {
    const pair = PHASE_LABELS[String(phase || "").toLowerCase().trim()];
    return pair ? pair[isGreek ? 1 : 0] : "\u2014";
  };

  // The worker's own progress lines. An unknown one -- an upstream API error,
  // say -- is shown as it came rather than dropped: a message nobody translated
  // is worth more than no message.
  const PROGRESS_MESSAGES_EL = {
    "running": "Σε εκτέλεση",
    "started": "Ξεκίνησε",
    "queued": "Σε αναμονή",
    "pending": "Σε αναμονή",
    "finished": "Ολοκληρώθηκε",
    "success": "Ολοκληρώθηκε",
    "failed": "Απέτυχε",
    "paused": "Σε παύση",
    "cancelled": "Ακυρώθηκε",
    "not started": "Δεν έχει ξεκινήσει",
    "cancelling…": "Ακύρωση σε εξέλιξη…",
    "simulation triggered successfully.": "Το αίτημα εκτέλεσης της προσομοίωσης καταχωρίστηκε επιτυχώς.",
    "simulation completed successfully.": "Η προσομοίωση ολοκληρώθηκε επιτυχώς.",
    "simulation failed. check message field for more details.": "Η προσομοίωση απέτυχε. Δείτε τις λεπτομέρειες στο πεδίο μηνύματος.",
    "failed to start simulation.": "Δεν ήταν δυνατή η έναρξη της προσομοίωσης.",
    "failed to cancel the run.": "Δεν ήταν δυνατή η ακύρωση της εκτέλεσης.",
    "cancellation requested. the run stops at its next checkpoint, which can take a few seconds while a long step finishes.": "Ζητήθηκε ακύρωση. Η εκτέλεση θα σταματήσει στο επόμενο σημείο ελέγχου. Μπορεί να χρειαστούν λίγα δευτερόλεπτα μέχρι να ολοκληρωθεί το τρέχον βήμα.",
    "the cancellation has been recorded and the run has not stopped yet. it will end at its next checkpoint.": "Η ακύρωση καταχωρίστηκε. Η εκτέλεση συνεχίζεται προσωρινά και θα σταματήσει στο επόμενο σημείο ελέγχου.",
    "starting feasibility simulation": "Έναρξη μελέτης σκοπιμότητας",
    "inputs validated": "Τα δεδομένα εισόδου επαληθεύτηκαν",
    "building timeseries": "Κατασκευή χρονοσειρών",
    "timeseries ready": "Οι χρονοσειρές είναι έτοιμες",
    "pv generation started": "Έναρξη υπολογισμού παραγωγής Φ/Β",
    "pv generation ready": "Η παραγωγή Φ/Β είναι έτοιμη",
    "pv-only energy balance and financial analysis": "Υπολογισμός ενεργειακού ισοζυγίου και οικονομικών αποτελεσμάτων μόνο Φ/Β",
    "pv-only energy balance and financial analysis complete": "Ολοκληρώθηκε το ενεργειακό ισοζύγιο και η οικονομική ανάλυση μόνο Φ/Β",
    "pv-only study complete": "Η μελέτη μόνο Φ/Β ολοκληρώθηκε",
    "pv generation skipped": "Ο υπολογισμός παραγωγής Φ/Β παραλείφθηκε",
    "reference study and integrated risk report": "Μελέτη αναφοράς και αναφορά οικονομικής αβεβαιότητας",
    "pv financial analysis completed": "Η οικονομική ανάλυση μεταβλητότητας ΦΒ ολοκληρώθηκε",
    "pv generation calculation": "Υπολογισμός παραγωγής ΦΒ",
    "pv generation skipped (no pv)": "Δεν απαιτείται υπολογισμός ΦΒ για αυτή τη μονάδα",
    "optimization started": "Έναρξη βελτιστοποίησης λειτουργίας",
    "optimization running": "Βελτιστοποίηση λειτουργίας",
    "creating proposal report": "Δημιουργία τεχνικής αναφοράς PDF",
    "creating summary presentation": "Δημιουργία συνοπτικής παρουσίασης",
    "creating detailed presentation": "Δημιουργία αναλυτικής παρουσίασης",
    "reference study": "Μελέτη αναφοράς",
    "finalizing study results": "Οριστικοποίηση αποτελεσμάτων μελέτης",
    "financial analysis": "Υπολογισμός οικονομικών αποτελεσμάτων",
    "results are available.": "Τα αποτελέσματα είναι διαθέσιμα.",
    "completed": "Η μελέτη ολοκληρώθηκε.",
    "simulation failed.": "Η μελέτη απέτυχε. Δείτε τις λεπτομέρειες του σφάλματος.",
    "uploading results": "Μεταφόρτωση αποτελεσμάτων",
    "cancelled by user.": "Ακυρώθηκε από τον χρήστη.",
    "dam energy prices api fetch failed (entso-e transparency platform). please retrigger the simulation.":
      "Η λήψη των τιμών ενέργειας DAM απέτυχε (ENTSO-E Transparency Platform). Εκτελέστε ξανά την προσομοίωση.",
    "api fetching error occurred. please retrigger the simulation.":
      "Παρουσιάστηκε σφάλμα κατά τη λήψη δεδομένων. Εκτελέστε ξανά την προσομοίωση.",
  };
  export const mapProgressMessage = (message, isGreek = false) => {
    const text = String(message || "").trim();
    if (!text || !isGreek) return text;
    const status = text.match(/^Simulation status: (.+)$/i);
    if (status) return `Κατάσταση προσομοίωσης: ${mapProgressMessage(status[1], true)}`;
    const month = text.match(/^Solving month (\d+) of (\d+)$/i);
    if (month) return `Υπολογισμός μήνα ${month[1]} από ${month[2]}`;
    const counter = text.match(/^(.*?) \| Case (\d+)\/(\d+) \| Pass (\d+)\/(\d+) \| Day (\d+)\/(\d+)$/);
    if (counter) return `${mapProgressMessage(counter[1], true)} · Σενάριο ${counter[2]}/${counter[3]} · Ετήσιο πέρασμα ${counter[4]}/${counter[5]} · Ημέρα ${counter[6]}/${counter[7]}`;
    const day = text.match(/^Optimization running \| Pass (\d+)\/(\d+) \| Day (\d+)\/(\d+)$/);
    if (day) return `Βελτιστοποίηση λειτουργίας · Ετήσιο πέρασμα ${day[1]}/${day[2]} · Ημέρα ${day[3]}/${day[4]}`;
    const metrics = text.match(/^Financial paths (\d+)\/(\d+)$/);
    if (metrics) return `Οικονομικές διαδρομές ${metrics[1]}/${metrics[2]}`;
    const battery = text.match(/^Optimization running: Battery (.+)$/);
    if (battery) return `Βελτιστοποίηση λειτουργίας · Μπαταρία ${battery[1]}`;
    if (/^P(?:10|50|90)$/.test(text)) return `Σενάριο παραγωγής ${text}`;
    const profiles = text.match(/^PV profiles · (\d+)$/);
    if (profiles) return `Προετοιμασία ωριαίων προφίλ ΦΒ · ${profiles[1]}`;
    const weather = text.match(/^Historical weather (\d+)$/);
    if (weather) return `Υπολογισμός λειτουργίας με ιστορικό καιρό ${weather[1]}`;
    const path = text.match(/^Path (\d+)\/(\d+) · (\d+)$/);
    if (path) return `Διαδρομή ${path[1]}/${path[2]} · ιστορικό έτος ${path[3]}`;
    return PROGRESS_MESSAGES_EL[text.toLowerCase()] || translateProjectFeasibilityText(text) || text;
  };

// Engine errors a user meets on a first study, rewritten as the next step to
// take and where. Matched in both languages: the English the engine sends
// ("Provide design_dict") means nothing to the user either.
const KNOWN_RUN_ERRORS = [
  [/at least one battery must be selected/i, [
    "Δεν έχει επιλεγεί μπαταρία, ενώ ο τύπος της μονάδας περιλαμβάνει αποθήκευση. Επιλέξτε μπαταρία στη Ρύθμιση Μονάδας → Αποθήκευση (BESS). Για μελέτη μόνο Φ/Β, αλλάξτε τον τύπο της μονάδας σε «Αυτόνομος Φ/Β σταθμός» (Ρύθμιση Μονάδας → Τοποθεσία & Γενικά → Αλλαγή τύπου μονάδας).",
    "No battery is selected, but the unit type includes storage. Select a battery under Unit Setup → Storage (BESS). For a PV-only study, change the unit type to \"Standalone PV plant\" (Unit Setup → Location & General → Change unit type).",
  ]],
  [/system design missing and auto-design disabled/i, [
    "Δεν υπάρχει αποθηκευμένος ηλεκτρολογικός σχεδιασμός Φ/Β. Ανοίξτε Ρύθμιση Μονάδας → ΦΒ Σύστημα → Ηλεκτρολογικός Σχεδιασμός & Διάταξη, πατήστε «Αυτόματος σχεδιασμός» και μετά «Αποθήκευση σχεδίου». Στη συνέχεια αποθηκεύστε το έργο και εκτελέστε ξανά τη μελέτη.",
    "There is no saved PV electrical design. Open Unit Setup → PV System → Electrical Design & Layout, press \"Auto-design\" and then \"Save design\". Then save the project and run the study again.",
  ]],
];

export function knownRunError(text, isGreek = false) {
  const hit = KNOWN_RUN_ERRORS.find(([pattern]) => pattern.test(String(text || "")));
  return hit ? hit[1][isGreek ? 0 : 1] : null;
}

export function mapSimulationError(error, isGreek = false) {
  const text = formatApiError(error, "Simulation failed.", { quota: "feasibility" });
  if (isDefaultMaintenanceMessage(text)) return maintenanceNotice(isGreek);
  const known = knownRunError(text, isGreek);
  if (known) return known;
  if (!isGreek || !text) return text;
  const translated = mapProgressMessage(text, true);
  if (translated !== text || /^[Α-Ωα-ωΆ-Ώά-ώ]/.test(text)) return translated;
  const rules = [
    [/server could not be reached|failed to fetch|network|load failed/i, "Δεν ήταν δυνατή η επικοινωνία με τον διακομιστή. Ελέγξτε την κατάσταση εκτέλεσης πριν δοκιμάσετε ξανά."],
    [/daily.*limit|limit.*today|today.*limit/i, "Έχετε φτάσει το ημερήσιο όριο εκτελέσεων του δοκιμαστικού λογαριασμού."],
    [/already running|another job|concurrent/i, "Εκτελείται ήδη άλλη εργασία. Περιμένετε να ολοκληρωθεί πριν ξεκινήσετε νέα."],
    [/demo.*expired/i, "Η δοκιμαστική περίοδος έχει λήξει."],
    [/account.*locked/i, "Ο λογαριασμός είναι κλειδωμένος."],
    [/not authorized|unauthorized|not authenticated|forbidden/i, "Δεν έχετε δικαίωμα εκτέλεσης αυτής της ενέργειας. Ελέγξτε ότι είστε συνδεδεμένοι."],
    [/rate limit|too many requests/i, "Έγιναν πάρα πολλά αιτήματα. Περιμένετε λίγο και δοκιμάστε ξανά."],
    [/time.?out|timed out/i, "Ξεπεράστηκε ο διαθέσιμος χρόνος αναμονής. Ελέγξτε την κατάσταση της προσομοίωσης."],
    [/infeasible|no feasible solution/i, "Δεν βρέθηκε εφικτή λύση. Ελέγξτε τα δεδομένα και τους περιορισμούς της προσομοίωσης."],
  ];
  for (const [pattern, message] of rules) {
    if (pattern.test(text)) return `${message} Λεπτομέρειες: ${text}`;
  }
  return `Παρουσιάστηκε σφάλμα στην προσομοίωση. Λεπτομέρειες: ${text}`;
}

export function normalizeRunStatus(raw) {
  const value = String(raw || "").toLowerCase().trim();
  if (["success", "completed", "finished", "done"].includes(value)) return "success";
  if (["failed", "error"].includes(value)) return "failed";
  if (["cancelled", "canceled"].includes(value)) return "cancelled";
  if (["running", "processing", "in_progress", "in-progress"].includes(value)) return "running";
  if (["not_started", "not started"].includes(value)) return "not_started";
  return "pending";
}
